import { render } from "./AuthorizationPage.vue?vue&type=template&id=64e00f63"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CONSULT\\PROJECTS\\_HTML\\baden-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__